<template>
  <div>
     <CRUDList
        ref="crudList"
        :canAdd="false"
        :canEdit="true"
        :canSave="true"
        :showSelect="false"
        :showDialog="true"
        :displayTopPagination="false"
        :headersWithColsSpan="headersWithColsSpan"
        :headers="headers"
        :baseCrudKey="baseCrudKey"
        :selectedItems="selectedItems"
        :defaultSortBy="defaultSortBy"
        :footerTotalDisplayColumnWise="['Total',null,null,'', '', '','','','','']"
        tableDynamicHeight="200"
        dialogDynamicWidth='400'
        dialogHeaderName="Payment Under Protest"
        tableWrapperDynamicClassname="taxroll-table-wrapper-two"
        @loadCRUDList="loadPickListsForProtestTax"
        @upsertItem="upsertTransaction"
        @emitSelectedItem="emitSelectedItem"
      > <template v-slot:[`editedItem`]="{}">
          <ProtestTaxDialog :baseCrudKey="baseCrudKey" :isItFromPicklist="true" />
        </template>
      </CRUDList>
    </div>
</template>
<script>
import {
  mapMutations, mapActions, mapState, mapGetters,
} from 'vuex';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import { ProtestPaymentsHeaders, ProtestPaymentsHeadersTwo } from '../TaxInquiryUtils/TableHeaders.utils';
import { amountToNumber } from '../../../../util/shared/vue-global';
import ProtestTaxDialog from '../../protestTax/ProtestTaxDialog.vue';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import '../../../../assets/style.css';

export default {
  name: 'ProtestTaxPaymentsList',
  data() {
    return {
      headers: ProtestPaymentsHeaders,
      baseCrudKey: 'ProtestTaxPaymentsList',
      baseCrudKeyTwo: 'pickListAddCommentsDialog',
      baseCrudKeyComments: 'taxComments',
      dialogHeaderName: 'Comments',
      headersWithColsSpan: ProtestPaymentsHeadersTwo,
      workstation: getWorkstationNumber(),
    };
  },
  components: {
    CRUDList,
    ProtestTaxDialog,
  },
  created() {
  },

  computed: {
    ...mapState({
      StoreSelItems: (state) => state.tax.taxInquiryTabs.slectedPickLists,
    }),
    ...mapGetters('base/crud', ['item', 'items', 'criteria']),
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setPickList(value);
      },
    },

    // new
    protestedTaxItemsGetter: {
      get() {
        const itemData = this.items('ProtestTaxPaymentsList');
        if (itemData) return itemData;
        return [];
      },
      set(value) {
        this.setItems(['ProtestTaxPaymentsList', value]);
      },
    },
    totalData() {
      let items = [];
      if (this.protestedTaxItemsGetter) items = this.protestedTaxItemsGetter;

      if (items.length === 0) {
        return {
          taxDue: 0,
          amtPaid: 0,
          amtStillDue: 0,
          amtPaidUnderProtest: 0,
          amtNoProtest: 0,
          amtPayment: 0,
        };
      }
      const totalDue = amountToNumber((items || []).reduce((total, item) => total
      + item.totalDue, 0));
      const totalAmtPaid = amountToNumber((items || []).reduce((total, item) => total
      + item.totalPaid, 0));
      const totalAmtStillDue = amountToNumber((items || []).reduce((total, item) => total
      + item.totalDue, 0));
      const totalAmtUnderProtest = amountToNumber((items || []).reduce((total, item) => total
      + item.amountPaidUnderProtest, 0));
      const totalAmtNoProtest = amountToNumber((items || []).reduce((total, item) => total
      + item.amountPaidNoProtest, 0));
      const totalAmtPayment = amountToNumber((items || []).reduce((total, item) => total
      + item.totalTax, 0));
      const total = {
        taxDue: totalDue,
        amtPaid: totalAmtPaid,
        amtStillDue: totalAmtStillDue,
        amtPaidUnderProtest: totalAmtUnderProtest,
        amtNoProtest: totalAmtNoProtest,
        amtPayment: totalAmtPayment,
      };
      return total;
    },
    defaultSortBy() {
      return [
        {
          column: '_id',
          direction: 'asc',
        },
      ];
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem', 'setItems']),
    ...mapMutations('tax/taxInquiryTabs', ['setPickList']),
    ...mapActions('tax/taxInquiryTabs', ['loadPickLists', 'deletePickList', 'upsertPickList']),
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    async postProccessData(items) {
      const updatedItems = [];
      for (let i = 0; i < items.length; i += 1) {
        const item = { ...items[i] };
        item.amountStillDue = item.totalTax - item.totalPaid;
        item.taxStillDue = item.totalDue - item.totalPaid;
        updatedItems.push(item);
      }
      return updatedItems;
    },
    loadPickListsForProtestTax() {
      const { baseCrudKey } = this;
      const pickListCriteria = this.criteria(baseCrudKey);
      const criteria = { ...pickListCriteria, workstation: Number(this.workstation) };
      this.loadPickLists({ criteria, baseCrudKey, postProcessTransaction: this.postProccessData });
    },
    async upsertTransaction(data) {
      const item = { ...data };
      item.totalPaid = item.totalPayment;
      const deletedFields = ['statusCode', 'mtgCode', 'adjustments', 'amountStillDue', 'amountPaid', 'feeList', 'statusCodes', 'taxDue', 'taxStillDue'];
      deletedFields.map((el) => {
        delete item[el];
        return item;
      });
      const amountFields = ['amountPaidNoProtest', 'amountPaidUnderProtest', 'totalDue', 'totalPaid', 'totalPayment'];
      amountFields.map((el) => {
        if (el in item) {
          item[el] = amountToNumber(item[el]);
        }

        return item;
      });
      await this.upsertPickList({ item, baseCrudKey: 'pickListTable' });
      this.loadPickListsForProtestTax();
    },

  },
};
</script>
